<svg-icon
  *ngIf="!hidden && !template"
  [name]="icon"
  [svgStyle]="{ 'width.px': 16, 'height.px': 16, fill: fillColor || 'currentColor' }"
  [ngClass]="class"
  [attr.name]="icon"
>
</svg-icon>

<ng-container *ngIf="!hidden && template" [ngTemplateOutlet]="template"> </ng-container>
